'use strict';

import $ from 'jquery';

const common = {
  init() {
    $('.js-question').on('click', function(e) {
      e.preventDefault();

      if ($('#' + $(this).attr('data-id')).hasClass('c-faq__content-active')) {
        $('#' + $(this).attr('data-id')).removeClass('c-faq__content-active');
      } else {
        $('#' + $(this).attr('data-id')).addClass('c-faq__content-active');
      }
    });

    $('.o-input--text').on('input', function() {
      var val = this.value.toLowerCase();

      $('.c-faq__content')
        .find('.js-question')
        .filter(function() {
          return (
            $(this)
              .data('title')
              .toLowerCase()
              .indexOf(val) > -1
          );
        })
        .show()
        .end()
        .filter(':visible')
        .filter(function() {
          return (
            $(this)
              .data('title')
              .toLowerCase()
              .indexOf(val) === -1
          );
        })
        .fadeOut();
    });
  },
};

const _this = common;

export default _this;
